import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";
import { colorTokens } from "theme/theme";

export const detailedSearchButtonStyle = css`
  cursor: pointer;
  width: 100%;
  border-radius: 6px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  ${MEDIA_QUERY_FOR_PC} {
    border: 1px solid #000000;
    padding: 10px 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    border: none;
    padding: 2px 0;
  }
`;

export const detailedSearchButtonTextStyle = css`
  line-height: 28px;
  font-size: 18px;
  margin-left: 8px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  color: ${colorTokens.colors["text.primary"].default};
`;
